export default {
  id: null,
  companyID: null,
  mechanicalWorkshopID: null,
  nameBudget: null,
  emailBudget: null,
  cellNumberBudget: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/workshopbudgetmodel.js